export default "__VITE_ASSET__CQ3zXzx1__"